import React from "react";
import Modals from "../../../../components/uiElements/popupModal/modal";
import RoundSlider from "./RoundSlider";

const PriceModal = ({
  minFee = 1,
  maxFee,
  fees,
  isOpen,
  onSuccess,
  closeModal,
  onUpdate,
}) => {
  return (
    <>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        height="0"
        width="0"
      >
        <defs>
          <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="0%"
              style={{
                "stop-color": "var(--active-tab-color)",
                "stop-opacity": "0.35",
              }}
            />

            <stop
              offset="95%"
              style={{
                "stop-color": "var(--active-tab-color)",
                "stop-opacity": "1",
              }}
            />
          </linearGradient>
        </defs>
      </svg>

      <Modals
        isOpen={isOpen}
        onRequestClose={() => closeModal}
        title="Do you want to change pricing?"
        styles={{
          content: {
            minWidth: "580px",
            maxWidth: "600px",
            minHeight: "485px",
            maxHeight: "500px",
          },
        }}
        btnDark={{
          label: "Send",
          onclick: () => {
            onSuccess();
            closeModal();
          },
        }}
      >
        <>
          <button
            onClick={closeModal}
            className="close modalCloseBtn"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="d-flex justify-content-center my-5">
            <RoundSlider
              sliderType="min-range"
              circleShape="pie"
              update={e => onUpdate(e.value)}
              value={fees}
              handleSize="+20"
              handleShape="round"
              min={minFee}
              max={maxFee}
              radius={125}
              width={33}
              handleColor="red"
              startAngle={315}
              borderWidth={0}
              editableTooltip={false}
              mouseScrollAction={true}
              lineCap="round"
              pathColor="url(#grad1)"
              rangeColor="transparent"
              animation="false"
            />
          </div>
        </>
      </Modals>
    </>
  );
};

export default PriceModal;
